import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VuetifyConfirm from 'vuetify-confirm';

import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';

import { createVuetifyProTipTap } from 'vuetify-pro-tiptap';

import store from './store';
import router from './router';
import i18n from './i18n';
import AuthenticationMixin from '@/mixins/AuthenticationMixin';

import { ApolloClient } from 'apollo-client';
import VueApollo from 'vue-apollo';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ENTRYPOINT } from '@/config/entrypoint';

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(VuetifyConfirm, { vuetify });
Vue.mixin(AuthenticationMixin);

Vue.use(TiptapVuetifyPlugin, {
  vuetify, // same as "vuetify: vuetify"
  iconsGroup: 'md'
});

const VuetifyProTipTap = createVuetifyProTipTap({
  vuetify,
  lang: 'de'
});
Vue.use(VuetifyProTipTap);

const httpLink = createHttpLink({
  uri: ENTRYPOINT + '/graphql',
});

const cache = new InMemoryCache();
const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
  ssrMode: false
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
   errorHandler: (error) => {
    if(error.networkError && error.networkError.statusCode === 401){
      store.commit('authentication/logout');
      location.reload(true);
    }
  }
});

new Vue({
  i18n,
  router,
  store,
  vuetify,
  apolloProvider,
  render: (h) => h(App)
}).$mount('#app');
